<div [ngClass]="labelTextTransformNone ? 'input-field-name-none': 'input-field-name'" *ngIf="labelName">{{labelName}}
  <span *ngIf="tooltiptxt" [ngbTooltip]=tooltiptxt placement="right" >
    <em
    class="fa fa-info-circle info-icon"
  ></em></span>
  <span class="optional" *ngIf="!isRequiredField && showOptionalLabel">({{OPTIONAL}})</span>
</div>
<div *ngIf="readOnlyMode"  class="readOnly">{{getDropdownValue()}}</div>
<select class="custom-select"
*ngIf="!readOnlyMode"
[ngClass]="getClasses()"
[formControl] = "inputFormControl"
(change)="onChange()"
>
  <option class="custom-option" [ngValue]="null"></option>
  <option class="custom-option" *ngFor="let option of options" [ngValue]="reqDropdownParentID ? option.masterID : option.dropdownID">{{reqDropdownParentID ? option.masterName : option.dropdownDesc}}</option>
</select>
<div *ngIf="showCommentIcon" class="comment-icon">
  <app-button [type]="(commentObject && commentObject.value && commentObject.value.length) ? 'commented-icon' : 'comment-icon' " (btnClick)="onShowComment.emit()"></app-button>
</div>
<div class="error" *ngIf="inputFormControl && !readOnlyMode && (submitted || inputFormControl.touched) && inputFormControl.errors">
  <div *ngIf="inputFormControl.errors.required">{{labelName}} is required</div>
</div>
